import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    if(
      to.path == '/'
      || to.path.includes('settings')
    ) {
      // console.log('[router.options.ts] Not scrolling to top')
      return savedPosition || false
    }

    // if to.path is same as from.path, do not scroll
    if(to.path === from.path) {
      // console.log('[router.options.ts] Not scrolling to top, same path')
      return false
    }

    // console.log('[router.options.ts] Scrolling to top')
    window?.scrollTo({
      top: 0,
    })
  }
}
